export default __webpack_public_path__ + "static/media/Iceland-3.926a23c5.webp";